import axiosInstance from './axiosInstance';

const ADSENSE_REQUEST_TIMEOUT = 120000;

export interface AdSenseRecord {
  id: string;
  url?: string;
  revenue?: number;
  pageView?: number;
  pageViewRevenuePerTD?: number;
  adViewCount?: number;
  adViewRevenuePerTD?: number;
  activeView?: number;
  clickCount?: number;
  date?: string;
  gameChannel?: string;
  gameChannels?: string[];
}

export interface AdSenseQuery {
  skip?: number;
  limit?: number;
  dateStart?: string | null;
  dateEnd?: string | null;
  gameChannel?: string | null;
  source?: 'manual' | 'google';
}

export interface AdSenseListResult {
  list: AdSenseRecord[];
  total: number;
}

export interface AdSenseUploadResult {
  total: number;
  successCount: number;
  failedCount: number;
  failed?: Array<{
    index: number;
    data: any;
    error: string;
  }>;
}

export interface AdSenseSyncResult {
  source: 'google';
  mode: 'sync';
  dateStart: string;
  dateEnd: string;
  days: number;
  reportRows: number;
  successCount: number;
  failedCount: number;
  list: Array<{
    date: string;
    total: number;
    successCount: number;
    failedCount: number;
    reportRows: number;
  }>;
}

export class AdSenseApi {
  /**
   * 获取AdSense数据列表
   */
  static async getList(query: AdSenseQuery = {}): Promise<AdSenseListResult> {
    const params: any = {}
    if (query.skip !== undefined) params.skip = query.skip
    if (query.limit !== undefined) params.limit = query.limit
    if (query.dateStart) params.dateStart = query.dateStart
    if (query.dateEnd) params.dateEnd = query.dateEnd
    if (query.gameChannel) params.gameChannel = query.gameChannel
    if (query.source) params.source = query.source
    
    const response = await axiosInstance.get('/cms/v1/adsense', {
      params,
      timeout: ADSENSE_REQUEST_TIMEOUT
    })
    return response.data.data
  }

  /**
   * 上传AdSense数据
   */
  static async upload(data: {
    date: string;
    jsonString: string;
    source?: 'manual' | 'google';
    gameChannel?: string;
  }): Promise<AdSenseUploadResult> {
    const response = await axiosInstance.post('/cms/v1/adsense', data, {
      timeout: ADSENSE_REQUEST_TIMEOUT
    })
    return response.data.data
  }

  /**
   * 从 AdSense 后台拉取并写入指定日期数据
   */
  static async pullFromGoogle(data: {
    date: string;
    gameChannel?: string;
  }): Promise<AdSenseUploadResult> {
    const response = await axiosInstance.post(
      '/cms/v1/adsense',
      {
        source: 'google',
        date: data.date,
        gameChannel: data.gameChannel || ''
      },
      { timeout: ADSENSE_REQUEST_TIMEOUT }
    )
    return response.data.data
  }

  /**
   * 从 AdSense 按时间段同步数据到数据库
   */
  static async syncRangeFromGoogle(data: {
    dateStart: string;
    dateEnd: string;
    gameChannel?: string;
  }): Promise<AdSenseSyncResult> {
    const response = await axiosInstance.post(
      '/cms/v1/adsense',
      {
        source: 'google',
        mode: 'sync',
        dateStart: data.dateStart,
        dateEnd: data.dateEnd,
        gameChannel: data.gameChannel || ''
      },
      { timeout: ADSENSE_REQUEST_TIMEOUT }
    )
    return response.data.data
  }

  /**
   * 删除AdSense记录
   */
  static async delete(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/adsense/${id}`)
  }
}
